import React, { useEffect, useState } from 'react';
import './Style.css';

const Services = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch('/Data/Service.json')
      .then((res) => res.json())
      .then((data) => setImages(data))
      .catch((err) => console.error('Error loading JSON:', err));
  }, []);

  return (
    <div>
      <div style={{ position: 'relative', width: '100%', height: '70vh' }}>
      <img
        src="/image/bg3.jpg" alt="Hotel" className="img-fluid" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      
      {/* Black semi-transparent overlay */}
      <div style={{
        position: 'absolute',
        top: 0, left: 0,
        width: '100%', height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // 0.4 মানে হালকা কালো
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        fontSize: '3rem',
        fontWeight: 'bold'
      }}>
        Services
      </div>
    </div>


    <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="container">
        <div className="d-flex flex-wrap justify-content-between gap-3">
          {images.map((image) => (
            <div key={image.id} className="image-container">
              <img
                src={image.image}
                alt={image.title}
                className="gallery-image"
              />
              <div className="overlay-title">{image.title}</div>
             
            </div>
          ))}
        </div>
      </div> 
    </section>
    </div>


  );
};
export default Services
